import React, { useEffect, useState } from 'react'
import logo from "../assets/logo.svg";
import { Link, useNavigate } from 'react-router-dom';
import '../sass/auth.scss'
import { auth, db } from '../firebase';
import { sendPasswordResetEmail, signInWithEmailAndPassword } from 'firebase/auth';
import { child, get, ref, set, update } from 'firebase/database';
import { loginUser } from '../api/user';

const Login = () => {

    const navigate = useNavigate()
    
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const handleError = (errorMsg) => {
        setError(errorMsg)
        setTimeout(() => {
            setError('')
        }, 3000);
    }


    const login = (e) => {
        e.preventDefault()
        setIsLoading(true)
        signInWithEmailAndPassword(auth, email, password)
        .then(async (userCredential) => {
            try {
                console.log(userCredential);
                const token = await  userCredential.user.getIdToken()
                console.log(token);
                const loginRequest = await loginUser(token)
                console.log("loginRequest", loginRequest)
                localStorage.setItem('uid', loginRequest.user_id)
                if(loginRequest.role === 'admin' || loginRequest.role === 'super-admin'){
                    localStorage.setItem('aid', loginRequest.user_id)
                    navigate('/admin/users');
                } else {
                    localStorage.removeItem('aid')
                    localStorage.setItem('mid', loginRequest.user_id)
                    navigate('/dashboard/panel');
                }
            } catch(err){
                handleError(err.message)
            } finally {
                setIsLoading(false)
            }
            // const user = userCredential.user
            // get(child(ref(db, 'users'), user.uid))
            // .then(snapshot => {
            //     if (snapshot.val().role === 'user') {
            //         localStorage.setItem('uid', user.uid)
            //         localStorage.removeItem('aid')
            //         localStorage.setItem('mid', user.uid)
            //         navigate('/dashboard/panel');
            //     } else if (snapshot.val().role === 'member') {
            //         if (snapshot.val().teams) {
            //             localStorage.setItem('uid', snapshot.val().teams[0])
            //             localStorage.setItem('mid', user.uid)
            //             localStorage.removeItem('aid')
            //             navigate('/dashboard/panel');
            //         } else {
            //             handleError('You\'re not a member of a team')
            //         }
            //     } else if (snapshot.val().role === 'admin' || snapshot.val().role === 'super-admin') {
            //         localStorage.setItem('uid', user.uid)
            //         localStorage.setItem('aid', user.uid)
            //         navigate('/admin/users');
            //     } else {
            //         localStorage.setItem('uid', user.uid)
            //         localStorage.setItem('mid', user.uid)
            //         localStorage.removeItem('aid', user.uid)
            //         navigate('/dashboard/panel');
            //     }
            // })
        })
        .catch((error) => {
            setIsLoading(false)
            const errorCode = error.code;
            console.log(errorCode)
            errorCode === 'auth/user-not-found' && handleError('User doesn\'t exist')
            errorCode === 'auth/wrong-password' && handleError('Incorrect Password')
            errorCode === 'auth/invalid-credential' && handleError('Invalid Login Credentials')
        });
    }


    // useEffect(() => {
    //     const usersArray = Object.entries(dbUsers).map(([id, user]) => (
    //         {
    //             id: id,
    //             ...user
    //         }
    //     ))
        
    //     usersArray.forEach(user => {
    //         update(child(ref(db, 'users'), user.id), {
    //             newReports: []
    //         })
    //     })
    // }, [])


  return (
    <div className='auth-page'>

        <form className="container py-5" onSubmit={login}>
            <div className="row">
                <div className="col-lg-6 auth-container">
                    <Link to={'/'} className='auth-logo'>
                        <img src={logo} alt="" />
                    </Link>

                    <h1>Login</h1>
                    <h6>
                        Please enter your email address and password to log in and access your account
                    </h6>
                    <h6 className='auth-message'>Don't have account? <Link to={'/signup'}>Signup</Link></h6>
                    <div className='auth-form'>
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className='auth-form-input' placeholder='Email' required />
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className='auth-form-input' placeholder='Password' required />
                    </div>

                </div>
            </div>
            <div className='row mt-4'>
                <div className='col-lg-6'>
                    {
                        error !== '' && <h5 className='text-danger text-center mb-3'>{error}</h5>
                    }
                    <button className='auth-form-btn' type='submit' disabled={isLoading}>
                        <span>{isLoading ? 'Logging...' : 'Login'}</span>
                    </button>
                    <h6 className='auth-message'>Forgot Your Password? <Link to={'/resetPassword'}>Reset Password</Link></h6>
                </div>
            </div>
        </form>
        
    </div>
  )
}

export default Login